import { TICKET_MANAGEMENT_TYPES } from '@constants/actionTypes/ticketActionTypes';

export const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action = {}) => {
    switch (action.type) {
        case TICKET_MANAGEMENT_TYPES.SET_TICKET:
            return action.ticketData;
        case TICKET_MANAGEMENT_TYPES.UPDATE_TICKET:
            return [ ...state, action.ticketData];
        default:
            return state;
    }
};